// Icons (SVG)
// Drawer
import config from '../../config';
import MyStoreSvg from '../../images/brand/icons/side-menu/my-store.svg';
import PromotionsSvg from '../../images/brand/icons/side-menu/promotions.svg';
import ResponsibleServiceSvg from '../../images/brand/icons/side-menu/responsible-service.svg';
import SelfExclusionSvg from '../../images/brand/icons/side-menu/self-exclusion.svg';
import WishListSvg from '../../images/brand/icons/side-menu/wishlist.svg';
import AccountIconUnfocused from '../../images/brand/svg/tabButtons/Account.svg';
import AccountIconFocused from '../../images/brand/svg/tabButtons/AccountFocused.svg';
import CartIconUnfocused from '../../images/brand/svg/tabButtons/Cart.svg';
import CartIconFocused from '../../images/brand/svg/tabButtons/CartFocused.svg';
// Unfocused
import CatalogueUnfocused from '../../images/brand/svg/tabButtons/Catalogue.svg';
// Bottom tabs
// Focused
import CatalogueFocused from '../../images/brand/svg/tabButtons/CatalogueFocused.svg';
import DiscoverIconUnfocused from '../../images/brand/svg/tabButtons/Discover.svg';
import DiscoverIconFocused from '../../images/brand/svg/tabButtons/DiscoverFocused.svg';
import ProductsIconUnfocused from '../../images/brand/svg/tabButtons/Products.svg';
import ProductsIconFocused from '../../images/brand/svg/tabButtons/ProductsFocused.svg';
import RewardsIconUnfocused from '../../images/brand/svg/tabButtons/Rewards.svg';
import RewardsIconFocused from '../../images/brand/svg/tabButtons/RewardsFocused.svg';
import SearchIconUnfocused from '../../images/brand/svg/tabButtons/Search.svg';
import SearchIconFocused from '../../images/brand/svg/tabButtons/SearchFocused.svg';
import ShopIconUnfocused from '../../images/brand/svg/tabButtons/Shop.svg';
import ShopIconFocused from '../../images/brand/svg/tabButtons/ShopFocused.svg';
import TodayIconUnfocused from '../../images/brand/svg/tabButtons/Today.svg';
import TodayIconFocused from '../../images/brand/svg/tabButtons/TodayFocused.svg';
import {AppRoute} from '../../models/AppRoute';
import BrandDetailScreen from '../../screens/articles/BrandDetailScreen';
import DiscoverListScreen from '../../screens/articles/DiscoverListScreen';
import ExclusiveOfferDetailScreen from '../../screens/articles/ExclusiveOfferDetailScreen';
import FavouriteBrandsScreen from '../../screens/articles/FavouriteBrandsScreen';
import FeedDiscoverDetailScreen from '../../screens/articles/FeedDiscoverDetailScreen';
import FeedListScreen from '../../screens/articles/FeedListScreen';
import PromotionDetailScreen from '../../screens/articles/PromotionDetailScreen';
import PromotionIFrameLinkScreen from '../../screens/articles/PromotionIFrameLinkScreen';
import PromotionsDrawnWinnersListScreen from '../../screens/articles/PromotionsDrawnWinnersListScreen';
import PromotionsListScreen from '../../screens/articles/PromotionsListScreen';
import RewardsListScreen from '../../screens/articles/RewardsListScreen';
import CartScreen from '../../screens/cart/CartScreen';
import CheckoutScreen from '../../screens/cart/CheckoutScreen';
import CatalogueScreen from '../../screens/catalogue/CatalogueScreen';
import {
  BRAND_NAME,
  DEPARTMENT_NAME,
  DISCOVER_FILTER,
  DISCOVER_SEGMENT,
  EXCLUSIVE_OFFER_LIST,
  EXCLUSIVE_OFFER_NAME,
  FAVOURITE_BRANDS,
  FILTER_MFL,
  FILTER_SEGMENT,
  MEMBERS_PRICE_LIST,
  ORDER_CONFIRMATION,
  PROCESSING_ORDER,
  PROMOTION_NAME,
  PROMOTIONS_CURRENT,
  PROMOTIONS_MAIN,
  PROMOTIONS_WINNERS,
  RESPONSIBLE_SERVICE,
  RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS,
  RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST,
  SEARCH,
  SELF_EXCLUSION,
  STORE_NAME,
  STORE_NAME_CARD,
  SUB_DEPARTMENT_NAME,
  VIEW_ORDER,
} from '../../screens/constants';
import DeveloperSettingsScreen from '../../screens/developer/DeveloperSettingsScreen';
import ExclusiveOfferListScreen from '../../screens/ExclusiveOfferListScreen';
import GiftCardsPromotionWaiter from '../../screens/giftCards/GiftCardsPromotionWaiter';
import HomepageScreen from '../../screens/HomepageScreen';
import KitchenSinkScreen from '../../screens/kitchensink/KitchenSinkScreen';
import MembersPriceListScreen from '../../screens/MembersPriceListScreen';
import OrderCompetitionScreen from '../../screens/OrderCompetitionScreen';
import OrderConfirmationScreen from '../../screens/OrderConfirmationScreen';
import PromotionsScreen from '../../screens/promotions/PromotionsScreen';
import ResponsibleServiceThirdPartyRequestScreen from '../../screens/responsibleService/HelpContactThirdPartyRequestScreen';
import LiquorLicensingLawsScreen from '../../screens/responsibleService/LiquorLicensingLawsScreen';
import ResponsibleServiceScreen from '../../screens/responsibleService/ResponsibleServiceScreen';
import SearchScreen from '../../screens/search';
import SelfExclusionScreen from '../../screens/selfExclusion/SelfExclusionScreen';
import DepartmentScreen from '../../screens/shop/DepartmentScreen';
import RangeProductDetailScreen from '../../screens/shop/RangeProductDetailScreen';
import ShopScreen from '../../screens/shop/ShopScreen';
import SubDepartmentScreen from '../../screens/shop/SubDepartmentScreen';
import StoreDetailScreen from '../../screens/StoreDetailScreen';
import StoreSwitchLinkScreen from '../../screens/StoreSwitchLinkScreen';
import WishlistScreen from '../../screens/WishlistScreen';
import {brandRewardsCopy} from '../../utils/rewards';
import {drawerIcon} from '../components/DrawerIcon';
import {header} from '../components/Header';
import {tabBarIcon} from '../components/TabBarIcon';

import {
  commonDrawerRouteProps,
  commonNoTabOrDrawerRouteProps,
  commonTabRouteProps,
} from './commonRouteProps';
import {RouteSpec, RouteWithoutTargetStoreType, TargetStoreType} from './types';

const findRouteIndex = (routes: RouteWithoutTargetStoreType[], routeName: AppRoute) => {
  return routes.findIndex(r => r.name === routeName);
}

const addOrUpdateRoute = (routes: RouteWithoutTargetStoreType[], route: RouteWithoutTargetStoreType) => {
  const index = findRouteIndex(routes, route.name);
  if (index === -1) {
    routes.push(route);
    return true;
  } else {
    routes[index] = route;
    return false;
  }
}

const replaceRoute = (routes: RouteWithoutTargetStoreType[], targetRouteName: AppRoute, route: RouteWithoutTargetStoreType) => {
  const index = findRouteIndex(routes, targetRouteName);
  if (index !== -1) {
    routes[index] = route;
  } else {
    throw new Error(`Unable to replace route: No route found for ${targetRouteName}`);
  }
}

const removeRoute = (routes: RouteWithoutTargetStoreType[], targetRouteName: AppRoute) => {
  const index = findRouteIndex(routes, targetRouteName);
  if (index !== -1) {
    routes.splice(index, 1);
  }
}

// Routes only reachable through navigation from tab or drawer screens
// (no on tab or drawer themselves)
const noTabOrDrawerRoutes: RouteWithoutTargetStoreType[] = [
  {
    name: AppRoute.ARTICLE,
    component: FeedDiscoverDetailScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: DISCOVER_SEGMENT,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTION,
    component: PromotionDetailScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTION_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PRODUCT,
    component: RangeProductDetailScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.DEPARTMENT,
    component: DepartmentScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: DEPARTMENT_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.SUB_DEPARTMENT,
    component: SubDepartmentScreen,
    header: header({
      back: true,
      filter: FILTER_MFL,
      burger: true,
      search: true,
      source: SUB_DEPARTMENT_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.FAVOURITE_BRANDS,
    component: FavouriteBrandsScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: FAVOURITE_BRANDS,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.BRAND,
    component: BrandDetailScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: BRAND_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTION_IFRAME,
    component: PromotionIFrameLinkScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTION_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CART_ORDER_CHECKOUT,
    component: CheckoutScreen,
    // https://github.com/react-native-webview/react-native-webview/issues/1915#issuecomment-800871646
    // animationEnabled: false, TODO XXX
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CART_ORDER_COMPETITIONS,
    component: OrderCompetitionScreen,
    header: header({
      back: false,
      filter: false,
      burger: true,
      search: false,
      source: PROCESSING_ORDER,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.CART_ORDER_CONFIRMATION,
    component: OrderConfirmationScreen,
    header: header({
      back: false,
      filter: false,
      burger: true,
      search: false,
      source: ORDER_CONFIRMATION,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTIONS_CURRENT,
    component: PromotionsListScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTIONS_CURRENT,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTIONS_WINNERS,
    component: PromotionsDrawnWinnersListScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTIONS_WINNERS,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS,
    component: LiquorLicensingLawsScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: RESPONSIBLE_SERVICE_LIQUOR_LICENSING_LAWS,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST,
    component: ResponsibleServiceThirdPartyRequestScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: RESPONSIBLE_SERVICE_THIRD_PARTY_REQUEST,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.NEW_SEARCH,
    component: SearchScreen,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: false,
      source: SEARCH,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.STORE_SWITCH_LINK,
    component: StoreSwitchLinkScreen,
    header: header({
      back: false,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  {
    name: AppRoute.GIFT_CARDS_PROMOTION_WAITER,
    component: GiftCardsPromotionWaiter,
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: VIEW_ORDER,
    }),
    ...commonNoTabOrDrawerRouteProps,
  },
  // {
  //   name: AppRoute.SUMMER_CASH_GRAB_GAME,
  //   component: SummerCashGrabScreen,
  //   header: header({
  //     back: true,
  //     shop: true,
  //     filter: false,
  //     burger: true,
  //     search: false,
  //     source: STORE_NAME,
  //   }),
  //   screenOptions: {
  //     presentation: 'modal',
  //   },
  //   ...commonNoTabOrDrawerRouteProps,
  // },
];

if (config.FF_LOYALTY_ENABLED) {
  noTabOrDrawerRoutes.push({
    name: AppRoute.EXCLUSIVE_OFFER_DETAIL,
    component: ExclusiveOfferDetailScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: EXCLUSIVE_OFFER_NAME,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });

  noTabOrDrawerRoutes.push({
    name: AppRoute.MEMBERS_PRICE_LIST,
    component: MembersPriceListScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: MEMBERS_PRICE_LIST,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });

  noTabOrDrawerRoutes.push({
    name: AppRoute.EXCLUSIVE_OFFER_LIST,
    component: ExclusiveOfferListScreen,
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: true,
      source: EXCLUSIVE_OFFER_LIST,
    }),
    ...commonNoTabOrDrawerRouteProps,
  });
}

const tabRoutes = (ecommerceDisabled: boolean, isLoggedIn: boolean, storeLoyaltyEnabled: boolean) => {
  let routes: RouteWithoutTargetStoreType[] = [
    config.FF_LOYALTY_ENABLED
      ? {
          name: AppRoute.HOME,
          component: HomepageScreen,
          title: 'HOME',
          icon: tabBarIcon(TodayIconFocused, TodayIconUnfocused),
          header: header({
            back: true,
            shop: true,
            filter: false,
            burger: true,
            search: true,
            source: STORE_NAME_CARD,
          }),
          ...commonTabRouteProps,
        }
      : {
          name: AppRoute.HOME,
          component: FeedListScreen,
          title: 'HOME',
          icon: tabBarIcon(TodayIconFocused, TodayIconUnfocused),
          header: header({
            back: true,
            shop: true,
            filter: false,
            burger: true,
            search: true,
            source: STORE_NAME,
          }),
          ...commonTabRouteProps,
        },
    {
      name: AppRoute.SHOP,
      component: ShopScreen,
      title: 'SHOP',
      icon: tabBarIcon(ShopIconFocused, ShopIconUnfocused),
      header: header({
        back: true,
        shop: true,
        filter: false,
        burger: true,
        search: true,
        source: STORE_NAME,
      }),
      ...commonTabRouteProps,
    },
    {
      name: AppRoute.DISCOVER,
      component: DiscoverListScreen,
      title: 'DISCOVER',
      icon: tabBarIcon(DiscoverIconFocused, DiscoverIconUnfocused),
      header: header({
        back: true,
        shop: false,
        filter: FILTER_SEGMENT,
        burger: true,
        search: true,
        source: DISCOVER_FILTER,
      }),
      ...commonTabRouteProps,
    },
    {
      name: AppRoute.CATALOGUE,
      component: CatalogueScreen,
      title: 'CATALOGUE',
      icon: tabBarIcon(CatalogueFocused, CatalogueUnfocused),
      header: header({
        back: true,
        shop: true,
        filter: false,
        burger: true,
        search: true,
        source: STORE_NAME,
      }),
      ...commonTabRouteProps,
    },
    {
      name: AppRoute.CART,
      component: CartScreen,
      title: 'CART',
      icon: tabBarIcon(CartIconFocused, CartIconUnfocused, true),
      header: header({
        back: true,
        shop: true,
        filter: false,
        burger: true,
        search: true,
        source: config.FF_LOYALTY_ENABLED ? STORE_NAME_CARD : STORE_NAME,
      }),
      ...commonTabRouteProps,
    },
  ];

  /**
   * FF loyalty enabled. Add functionality so that non ecommerce stores show different
   * bottom tabs
   */
  if (config.FF_LOYALTY_ENABLED) {
    const tabDiscoverRouteIndex = findRouteIndex(routes, AppRoute.DISCOVER);
    if (tabDiscoverRouteIndex < 0) {
      throw new Error('DEV DEBUG: No DISCOVER route in Tab Routes. Are you sure this is the right NAV state?')
    }
    if (storeLoyaltyEnabled) {
      replaceRoute(routes, AppRoute.DISCOVER, {
        name: AppRoute.REWARDS,
        component: RewardsListScreen,
        title: brandRewardsCopy.menuTitle.toUpperCase(),
        icon: tabBarIcon(RewardsIconFocused, RewardsIconUnfocused),
        header: header({
          back: true,
          shop: false,
          filter: false,
          burger: true,
          search: true,
          source: STORE_NAME,
        }),
        ...commonTabRouteProps,
      });

      // Since we replaced DISCOVER with REWARDS, we need to add it back to the noTabOrDrawerRoutes
      addOrUpdateRoute(noTabOrDrawerRoutes, {
        name: AppRoute.DISCOVER,
        component: DiscoverListScreen,
        header: header({
          back: true,
          shop: false,
          filter: FILTER_SEGMENT,
          burger: true,
          search: true,
          source: DISCOVER_FILTER,
        }),
        ...commonNoTabOrDrawerRouteProps,
      });

      removeRoute(noTabOrDrawerRoutes, AppRoute.REWARDS);
    } else { // When Store Loyalty is disabled
      // Add Rewards route to noTabOrDrawerRoutes
      addOrUpdateRoute(noTabOrDrawerRoutes, {
        name: AppRoute.REWARDS,
        component: RewardsListScreen,
        header: header({
          back: true,
          shop: false,
          filter: false,
          burger: true,
          search: true,
          source: STORE_NAME,
        }),
        ...commonNoTabOrDrawerRouteProps,
      });
      
      removeRoute(routes, AppRoute.REWARDS);
      removeRoute(noTabOrDrawerRoutes, AppRoute.DISCOVER);
    }

    if (ecommerceDisabled) { 
      routes = [
        {
          name: AppRoute.HOME,
          component: FeedListScreen,
          title: 'HOME',
          icon: tabBarIcon(TodayIconFocused, TodayIconUnfocused),
          header: header({
            back: true,
            shop: true,
            filter: false,
            burger: true,
            search: true,
            source: STORE_NAME,
          }),
          ...commonTabRouteProps,
        },
        {
          name: AppRoute.SHOP,
          component: ShopScreen,
          title: 'SHOP',
          icon: tabBarIcon(ProductsIconFocused, ProductsIconUnfocused),
          header: header({
            back: true,
            shop: true,
            filter: false,
            burger: true,
            search: true,
            source: STORE_NAME,
          }),
          ...commonTabRouteProps,
        },
        {
          name: AppRoute.CATALOGUE,
          component: CatalogueScreen,
          title: 'CATALOGUE',
          icon: tabBarIcon(CatalogueFocused, CatalogueUnfocused),
          header: header({
            back: true,
            shop: true,
            filter: false,
            burger: true,
            search: true,
            source: STORE_NAME,
          }),
          ...commonTabRouteProps,
        },
        {
          name: AppRoute.DUMMY_SEARCH,
          component: Nothing,
          title: 'SEARCH',
          icon: tabBarIcon(SearchIconFocused, SearchIconUnfocused),
          listeners: ({navigation}) => ({
            tabPress: e => {
              e.preventDefault();
              navigation.navigate(AppRoute.NEW_SEARCH);
            },
          }),
          ...commonTabRouteProps,
        },
        {
          name: AppRoute.DUMMY_ACCOUNT,
          component: Nothing,
          title: 'Account',
          icon: tabBarIcon(AccountIconFocused, AccountIconUnfocused),
          listeners: ({navigation}) => ({
            tabPress: e => {
              e.preventDefault();
              navigation.navigate(
                isLoggedIn
                  ? AppRoute.ACCOUNT_LOGGED_IN
                  : AppRoute.ACCOUNT_NOT_LOGGED_IN,
              );
            },
          }),
          ...commonTabRouteProps,
        },
      ];
    }
  }

  return routes;
};

function Nothing() {
  return null;
}

const drawerRoutes: RouteWithoutTargetStoreType[] = [
  {
    name: AppRoute.MY_STORE,
    component: StoreDetailScreen,
    title: 'My Store',
    icon: drawerIcon(MyStoreSvg),
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    drawerSortOrder: 1,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.WISHLIST,
    component: WishlistScreen,
    title: 'Wish list',
    icon: drawerIcon(WishListSvg),
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: STORE_NAME,
    }),
    drawerSortOrder: 3,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.PROMOTIONS,
    component: PromotionsScreen,
    title: 'Promotions',
    icon: drawerIcon(PromotionsSvg),
    header: header({
      back: true,
      shop: false,
      filter: false,
      burger: true,
      search: true,
      source: PROMOTIONS_MAIN,
    }),
    drawerSortOrder: 4,
    ...commonDrawerRouteProps,
  },

  {
    name: AppRoute.RESPONSIBLE_SERVICE,
    component: ResponsibleServiceScreen,
    title: 'Responsible Service',
    icon: drawerIcon(ResponsibleServiceSvg),
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: RESPONSIBLE_SERVICE,
    }),
    drawerSortOrder: 8,
    ...commonDrawerRouteProps,
  },
  {
    name: AppRoute.SELF_EXCLUSION,
    component: SelfExclusionScreen,
    title: 'Self Exclusion',
    icon: drawerIcon(SelfExclusionSvg),
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
      source: SELF_EXCLUSION,
    }),
    drawerSortOrder: 9,
    ...commonDrawerRouteProps,
  },
];

if (config.KITCHENSINK_ENABLED) {
  drawerRoutes.push({
    name: AppRoute.KITCHENSINK_INDEX,
    component: KitchenSinkScreen,
    title: 'Kitchen Sink',
    header: header({
      back: true,
      shop: true,
      filter: false,
      burger: true,
      search: true,
    }),
    drawerSortOrder: 999,
    ...commonDrawerRouteProps,
  });

  drawerRoutes.push({
    name: AppRoute.DEVELOPER_SETTINGS,
    component: DeveloperSettingsScreen,
    title: 'Developer Settings',
    header: header({
      back: true,
      filter: false,
      burger: true,
      search: false,
    }),
    drawerSortOrder: 999,
    ...commonDrawerRouteProps,
  });
}

const liquorStoreAppRoutes = (
  ecommerceDisabled: boolean,
  isLoggedIn: boolean,
  storeLoyaltyEnabled: boolean,
) =>
  [
    ...drawerRoutes,
    ...tabRoutes(ecommerceDisabled, isLoggedIn, storeLoyaltyEnabled),
    ...noTabOrDrawerRoutes,
  ].map(routeWithNoTargetStoreType => {
    const route: RouteSpec = {
      ...routeWithNoTargetStoreType,
      targetStoreType: TargetStoreType.LiquorStore,
    };
    return route;
  });

export default liquorStoreAppRoutes;
